
import React, { useEffect } from 'react'
import { Row, Col, Dropdown } from 'react-bootstrap'
import Card from '../../../components/Card'
import '@fortawesome/fontawesome-free/css/all.css';
import { Calendar, momentLocalizer } from 'react-big-calendar'
import * as moment from 'moment'
import "react-big-calendar/lib/css/react-big-calendar.css";
import { useNavigate } from 'react-router-dom'
import { organisationSignal } from '../../../signal/organisationSignal';

const localizer = momentLocalizer(moment)


const Attendence = ({ attendences, fromDate, toDate }) => {

    const navigate = useNavigate();
    const [attendenceMap, setAttendenceMap] = React.useState({})
    useEffect(() => {
        let temp = {};
        attendences.map((item) => {
            if (!item.isPresent && item.leaveId === "000000000000000000000000") {
                return
            }
            temp[moment(item?.startTime).format('DD/MM/YYYY')] = item;
        })

        let start = moment(fromDate);
        let end = moment(toDate);

        while (start <= end) {
            if (!temp[moment(start).format('DD/MM/YYYY')]) {
                let isThisSaturday = moment(start).day() === 6;
                let isThisSunday = moment(start).day() === 0;
                let thisDate = moment(start).format('DD/MM');
                let isHoliday = false;

                if (isThisSaturday && !organisationSignal?.value?.isSaturdayWorking) {
                    isHoliday = true;
                }
                else if (isThisSunday && !organisationSignal?.value?.isSundayWorking) {
                    isHoliday = true;
                }
                else if (organisationSignal?.value?.holidays !== undefined) {
                    if (organisationSignal?.value?.holidays[thisDate]) {
                        isHoliday = true;
                    }
                }

                if (!isHoliday) {
                    temp[moment(start).format('DD/MM/YYYY')] = {
                        isPresent: false
                    }
                }

            }
            start = moment(start).add(1, 'days');
        }
        setAttendenceMap(temp);
    }, [attendences, fromDate, toDate])

    return (
        <>
            <Col lg="12">
                <Row>
                    <Col lg="12" className="col-lg-12" style={{ height: "500px" }}>
                        <Card>
                            <Card.Body>
                                <Calendar
                                    style={{ height: "800px" }}
                                    localizer={localizer}
                                    events={
                                        attendences?.length > 0 ? attendences.map((attendence) => {
                                            if (!attendence.isPresent && attendence.leaveId === "000000000000000000000000") {
                                                return
                                            }
                                            return {
                                                title: attendence.isPresent ? `Trip ${moment(attendence.startTime).format("hh:mm A")} - ${moment(attendence.endTime).format("hh:mm A")}` : "Leave",
                                                start: new Date(attendence.startTime),
                                                end: new Date(attendence.endTime),
                                                backgroundColor: attendence.isPresent ? "#3a57e8" : "#eb991b",
                                                tripId: attendence.tripId,
                                                leaveId: attendence.leaveId,
                                                isPresent: attendence.isPresent
                                            }
                                        }) : []
                                    }
                                    date={fromDate}
                                    dayPropGetter={
                                        (date) => {
                                            if (attendenceMap[moment(date).format('DD/MM/YYYY')]) {
                                                return {
                                                    style: {
                                                        backgroundColor: attendenceMap[moment(date).format('DD/MM/YYYY')].isPresent ? "lightgreen" : "lightcoral",
                                                    }
                                                }
                                            }
                                        }
                                    }
                                    eventPropGetter={
                                        (event) => {
                                            return {
                                                style: {
                                                    backgroundColor: event.backgroundColor,
                                                }
                                            }
                                        }
                                    }

                                    onSelectEvent={(event) => {
                                        if (event?.isPresent) {
                                            navigate(`/dashboard/trips/${event.tripId}`)
                                        } else {
                                            navigate(`/dashboard/leaves?search=${event.leaveId}`)
                                        }
                                    }}
                                />
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Col>
        </>
    )
}

export default Attendence
